import InfoIcon from 'components/ReusableComponents/Icons/Info'

import styles from './Tutorial.module.scss'

const TutorialTrigger = ({ onClick, label = 'Tutorial', className = '' }) => {
  return (
    <button
      type="button"
      className={[styles.trigger, className].filter(Boolean).join(' ')}
      onClick={onClick}
    >
      <span>{label}</span>
      <InfoIcon className={styles.triggerIcon} />
    </button>
  )
}

export default TutorialTrigger
